import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import ChangeContainer from './ChangeContainer'


const ChangeRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><ChangeContainer></ChangeContainer></Provider>
}

ChangeRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default ChangeRoot
